export const handleBack = (role, navigate) => {
  //  debugger;
  switch (role) {
    case "admin":
      navigate("/admin/dashboard");
      break;
    case "staff":
      navigate("/staff/dashboard");
      break;
    case "super-admin":
      navigate("/super-admin/dashboard");
      break;
    case "player":
      navigate("/player/payment-history");
      break;
    case "coach":
      navigate("/coach/attendance");
      break;
    default:
      navigate("/dashboard");
      break;
  }
};
